































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class FormInput extends Vue {
    @Prop({ type: String, default: '' }) value!: string
    @Prop({ type: Boolean }) multiline!: boolean
    @Prop({ type: Number }) maxLength!: number

    onInput(event: { target: HTMLInputElement }) {
        const text = this.maxLength ? event.target.value.slice(0, this.maxLength) : event.target.value
        this.$emit('input', text)
        this.$forceUpdate()
    }
}
